import { defineStore } from 'pinia';
import { ref } from 'vue'; 

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    mainMessage: '검사결과지를 준비중입니다.', 
    subMessage: '', 
    reportDownloadType: '', // 학급용 학교장용 학생용
    isDownloading: false, // 다운로드 중인지 여부
    isLoadingOverlay: true,
  }),
  getters: {
    downloadButtonText: (state) => {
      if (state.isDownloading) {
        return '다운로드 중...';
      }
      if (state.reportDownloadType === '학급용') {
        return '학급용 검사결과지 PDF 다운로드';
      } else if (state.reportDownloadType === '학생용') {
        return '학생용 검사결과지 PDF 다운로드';
      }
      else if (state.reportDownloadType === '학교장용') {
        return '학교장용 검사결과지 PDF 다운로드';
      }
      else if (state.reportDownloadType === '전체학생용') { 
        return '전체 학생 검사결과지 PDF 다운로드';
      }
      else if (state.reportDownloadType === '우리학교용') { 
        return '우리 학교 반별 진단결과지 PDF 다운로드';
      }
      return '검사결과지 PDF 다운로드'; // 기본값 또는 알 수 없는 값일 때
    },
  },
  actions: {
    // 초기 로딩 메시지&타입 설정
    setLoadingMessages(mainMsg, subMsg, reportType) {
      this.mainMessage = mainMsg;
      this.subMessage = subMsg;
      this.reportDownloadType = reportType;
    },
    startDownloading() {
      this.isDownloading = true;
    },
    stopDownloading() {
      this.isDownloading = false;
    },
    setLoadingOverlay(status) { 
      this.isLoadingOverlay = status;
      console.log(`[LoadingStore] isLoadingOverlay set to: ${status}`); // 디버깅용
    }
  }
});